const incisioneId = "53014017442135:c600bb9806d58a043586912cd4228c49"
const confezioneId = "52700301492567:77a2100df47b8d192141ed34798117c6"

document.addEventListener('DOMContentLoaded', () => {
  // fetch('/cart/clear.js')

  const observer = new MutationObserver(function(mutations) {
    removeChangeButtonForIncisioni()
    removeChangeButtonForConfezione()
  });
  const config = { attributes: true, childList: true, characterData: true };
  observer.observe(document.querySelector("#cart-drawer"), config);

  removeChangeButtonForIncisioni()
  removeChangeButtonForConfezione()
})

function removeChangeButtonForIncisioni() {  
  const changeQuantity = document?.querySelector(`a[href^="/cart/change?id=${incisioneId}"]`)
  const href = changeQuantity?.getAttribute('href')
  const params = new URL(`https://test.local${href}`).searchParams;

  const changeQuantityParent = changeQuantity?.parentElement
  const changeQuantityParentParent = changeQuantityParent?.parentElement

  changeQuantityParentParent?.querySelector('.line-item__remove-button')?.remove()
  document?.querySelector(`input[data-line-key="${params.get('id')}"]`)?.setAttribute('disabled', true)

  changeQuantityParent?.querySelectorAll('a')?.forEach(el => {
    el?.removeAttribute('href')
    el?.setAttribute('disabled', true)
  })

  if (changeQuantityParentParent) {
    changeQuantityParentParent.innerHTML = `${changeQuantityParentParent?.innerHTML}<span hidden id="incisione-id">${params.get('id')}</span>` 
  }

  const previewProduct = changeQuantityParentParent?.parentElement?.parentElement?.querySelector('a[href]')
  previewProduct?.removeAttribute('href')
  previewProduct?.setAttribute('disabled', true)
}   

function removeChangeButtonForConfezione() {
  const changeQuantity = document?.querySelector(`a[href^="/cart/change?id=${confezioneId}"]`)
  const href = changeQuantity?.getAttribute('href')
  const params = new URL(`https://test.local${href}`).searchParams;

  const changeQuantityParent = changeQuantity?.parentElement
  const changeQuantityParentParent = changeQuantityParent?.parentElement

  changeQuantityParentParent?.querySelector('.line-item__remove-button')?.remove()
  document?.querySelector(`input[data-line-key="${params.get('id')}"]`)?.setAttribute('disabled', true)

  changeQuantityParent?.querySelectorAll('a')?.forEach(el => {
    el?.removeAttribute('href')
    el?.setAttribute('disabled', true)
  })

  if (changeQuantityParentParent) {
    changeQuantityParentParent.innerHTML = `${changeQuantityParentParent?.innerHTML}<span hidden id="confezione-id">${params.get('id')}</span>` 
  }

  const previewProduct = changeQuantityParentParent?.parentElement?.parentElement?.querySelector('a[href]')
  previewProduct?.removeAttribute('href')
  previewProduct?.setAttribute('disabled', true)
}   

(function(ns, fetch) {
  if (typeof fetch !== 'function') return;

  ns.fetch = async function() {

    if (arguments[0] === "/cart/add.js") {
      const body = arguments[1].body      

      if (body.get('properties[Incisione-PY]') !== '') {
        const incrementProduct = document.querySelector('#price_increment_id').value
        const isIncrement = document.querySelector('#is_price_increment').value
        const bodyForAddon = new FormData()
        for (const pair of body.entries()) {
          console.log(pair[0], pair[1]);
          bodyForAddon.append(pair[0], pair[1])
        }

        if (isIncrement == 'true') {
          bodyForAddon.set('id', incrementProduct)
          bodyForAddon.set('product-id', incrementProduct)
          bodyForAddon.set("properties[Incisione-PY]",'')
          bodyForAddon.set("properties[Confezione regalo]",'')
          
          await fetch.apply(this, [arguments[0], {...arguments[1], body: bodyForAddon}])
        }
      } 
      if (body.get('properties[Confezione regalo]') !== '') {
        const wrapProduct = document.querySelector('.product-addon-checkbox').getAttribute('data-product-id');
        const bodyForAddon = new FormData()
        for (const pair of body.entries()) {
          console.log(pair[0], pair[1]);
          bodyForAddon.append(pair[0], pair[1])
        }

        bodyForAddon.set('id', wrapProduct)
        bodyForAddon.set('product-id', wrapProduct)
        bodyForAddon.set("properties[Incisione-PY]",'')
        bodyForAddon.set("properties[Confezione regalo]",'')

        await fetch.apply(this, [arguments[0], {...arguments[1], body: bodyForAddon}])
      } 

      return fetch.apply(this, arguments);
    } else if (arguments[0] === "/cart/change.js") {

      const body = JSON.parse(arguments[1].body)
      const id = body.id  
      const listRole = document.querySelector(`a[href^="/cart/change?id=${id}"]`).parentElement.parentElement.parentElement.parentElement.querySelector('ul[role="list"').innerHTML
      
      let response = await fetch.apply(this, arguments);
      const data = await response.clone().json()

      if (/incisione-py/gi.test(listRole)) {

        const id = document.querySelector(`#incisione-id`)?.innerHTML
        if (id) {
          if (data.items_removed.length > 0) {
            const {quantity} = data.items_removed[0]
            const startQuantity = parseInt(document.querySelector(`input[data-line-key="${id}"]`).value)

            response = await fetch('/cart/change.js', {
              method: arguments[1].method,
              headers: arguments[1].headers,
              body: JSON.stringify({ id, quantity: startQuantity - quantity, sections: body.sections })
            })
          } else {
            const {quantity} = data.items_added[0]
            const startQuantity = parseInt(document.querySelector(`input[data-line-key="${id}"]`).value)

            response = await fetch('/cart/change.js', {
              method: arguments[1].method,
              headers: arguments[1].headers,
              body: JSON.stringify({ id, quantity: startQuantity + quantity, sections: body.sections })
            })
          }
        }
      }
      if (/confezione/gi.test(listRole)) {
        const id = document.querySelector(`#confezione-id`).innerHTML
        if (data.items_removed.length > 0) {
          const {quantity} = data.items_removed[0]
          const startQuantity = parseInt(document.querySelector(`input[data-line-key="${id}"]`).value)

          response = await fetch('/cart/change.js', {
            method: arguments[1].method,
            headers: arguments[1].headers,
            body: JSON.stringify({ id, quantity: startQuantity - quantity, sections: body.sections })
          })
        } else {
          const {quantity} = data.items_added[0]
          const startQuantity = parseInt(document.querySelector(`input[data-line-key="${id}"]`).value)

          response = await fetch('/cart/change.js', {
            method: arguments[1].method,
            headers: arguments[1].headers,
            body: JSON.stringify({ id, quantity: startQuantity + quantity, sections: body.sections })
          })
        }
      }

      return response
    }
    
    return fetch.apply(this, arguments);
  }

}(window, window.fetch))